import { Route } from 'types/route.type';
import RegistrationLog from './registration-log';

export const routes: Route[] = [
  {
    path: '/production-systems/registration-log/:globalSiteId?',
    component: RegistrationLog,
    id: 'productionSystems.registrationLog.title',
  },
];
